import EnterLayout from 'components/enter2026/EnterLayout';
import MainLayout from 'components/layout/MainLayout';
import TealCircleTicket from '../../components/svg/TealCircleTicket.svg';
import { GetServerSideProps } from 'next';
import { tryApi } from 'utils/api/common';
import { drawApiClient } from 'utils/apiClient';
import HttpStatusCode from 'utils/HttpStatusCode';
import { MainDrawTypeCode } from 'constants/Draw';
import EnterDrawCountdown from 'components/enter2026/EnterDrawCountdown';
import ImageWithFallback from 'components/ImageWithFallback';
import styles from './1a.module.css';
import { runningInProduction } from 'utils/constants';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface EnterNowStep1Props {
  nextDrawDateIsoString: string | null;
}

const EnterNowStep1 = (props: EnterNowStep1Props) => {
  const router = useRouter();
  useEffect(() => {
    if (runningInProduction) {
      router.replace('/enternow/1');
    }
  }, []);
  return (
    <MainLayout limitItemWidths>
      <EnterLayout
        sidePanel={
          <>
            <EnterDrawCountdown date={props.nextDrawDateIsoString} />
            <div className={styles.winnerImage}>
              <ImageWithFallback
                src="https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/enter/EnterStep1.png"
                alt="Photo of winner Harriet G, who won a Japan trip for 2 worth £25,000"
                layout="responsive"
                width="936"
                height="1072"
              />
            </div>
          </>
        }
        sidePanelBackground={'TEAL'}
        stepIcon={<TealCircleTicket />}
        stepName="Lucky Numbers"
        stepIntroText="The more numbers you match correctly, the bigger the prize you can choose."
        stepIndex={0}
        stepTooltipContent={
          <div>
            <p>
              Select how many entries you would like in our weekly prize draw.
              The more entries you choose, the more chances you have to win.
              Winners are selected at random every week.
            </p>
          </div>
        }
      >
        {' '}
      </EnterLayout>
    </MainLayout>
  );
};

export default EnterNowStep1;

export const getServerSideProps: GetServerSideProps<
  EnterNowStep1Props
> = async (_ctx) => {
  const [resp] = await Promise.all([
    tryApi(
      drawApiClient.public.getDrawTypeCached({
        params: { draw_code: MainDrawTypeCode },
      }),
    ),
  ]);

  let nextDrawDate: string | null = null;

  if (resp.status === HttpStatusCode.OK) {
    if (resp.body.next_draw?.drawDate) {
      nextDrawDate = new Date(resp.body.next_draw.drawDate).toISOString();
    }
  }

  return {
    props: {
      nextDrawDateIsoString: nextDrawDate,
    },
  };
};
